/* Aparición suave de los bloques al entrar en pantalla.
   Se aplica a cualquier elemento con la clase .bm-reveal.
   Si el visitante pidió menos animación, no hace nada. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Marca el documento para que el CSS active el efecto. Sin esta clase el
  // contenido se ve siempre: si este script no corre, la página no queda vacía.
  if (!reduce && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('bm-js');
  }

  // Red de seguridad: pase lo que pase, a los 3 segundos todo queda visible.
  setTimeout(function () {
    var pending = document.querySelectorAll('.bm-reveal:not(.is-in)');
    for (var i = 0; i < pending.length; i++) pending[i].classList.add('is-in');
  }, 3000);

  function showAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
  }

  function init() {
    var nodes = document.querySelectorAll('.bm-reveal:not(.is-in)');
    if (!nodes.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      showAll(nodes);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    for (var i = 0; i < nodes.length; i++) io.observe(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de temas recarga secciones sin recargar la página.
  document.addEventListener('shopify:section:load', init);
})();
